import axios from 'axios';

// Create axios instance with interceptor
const axiosInstance = axios.create();

// Add interceptor to include auth token
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axiosInstance;
